import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Shield } from "lucide-react";
import { GeneratorCard } from "./GeneratorCard";

export const PasswordGenerator = () => {
  const location = useLocation();
  const { t } = useTranslation("generator");
  const prefill = location.state?.password || "";
  const prefillMode = location.state?.mode || "readable";
  const features = [
    { t: t("trust.readOnceTitle"), d: t("trust.readOnceDesc") },
    { t: t("trust.expireTitle"), d: t("trust.expireDesc") },
    { t: t("trust.noAccountTitle"), d: t("trust.noAccountDesc") },
  ];
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-start">
      <div className="lg:col-span-7">
        <GeneratorCard variant="page" initialPassword={prefill} initialMode={prefillMode} />
      </div>

      {/* Right: trust panel */}
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, delay: 0.08 }}
        className="lg:col-span-5 space-y-4"
      >
        <div className="glass rounded-2xl p-6">
          <div className="w-11 h-11 rounded-xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center mb-4">
            <Shield className="w-5 h-5 text-emerald-600" />
          </div>
          <h3 className="font-heading text-lg font-semibold mb-2">{t("trust.zkTitle")}</h3>
          <p className="text-sm text-slate-500 leading-relaxed">
            {t("trust.zkDesc")}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4">
          {features.map((f) => (
            <div key={f.t} className="rounded-xl bg-slate-50 border border-slate-200 px-5 py-4">
              <div className="text-sm font-semibold text-slate-900 mb-1">{f.t}</div>
              <div className="text-xs text-slate-500 leading-relaxed">{f.d}</div>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};
